"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var ButtonFavorite_vue_1 = __importDefault(require("../button-favorite/ButtonFavorite.vue"));
var video_preview_1 = require("../video-preview/video-preview");
var ShareModal_vue_1 = __importDefault(require("../share/ShareModal.vue"));
var VideoShow = /** @class */ (function (_super) {
    __extends(VideoShow, _super);
    function VideoShow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchPageUrl = '/local/api/videos';
        _this.visiblePageUrl = '/video-library';
        _this.fetchingPage = true;
        _this.video = null;
        _this.itemsContainerClasses = ['row', 'p-0'];
        _this.itemWrapperClasses = ['mb-3', 'col-12', 'col-md-6', 'col-lg-4', 'col-xl-3'];
        return _this;
    }
    VideoShow.prototype.created = function () {
        var _this = this;
        this.scrollTop();
        this.$watch(function () { return _this.slug; }, function () {
            _this.scrollTop();
            _this.getVideoData();
        }, { immediate: true, deep: true });
    };
    Object.defineProperty(VideoShow.prototype, "enableShare", {
        get: function () {
            return this.video !== null && this.video.share !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoShow.prototype, "videoLibraryUrl", {
        get: function () {
            return this.buildUrl(this.visiblePageUrl);
        },
        enumerable: false,
        configurable: true
    });
    VideoShow.prototype.showNext = function () {
        this.$emit('show-next');
    };
    VideoShow.prototype.showPrev = function () {
        this.$emit('show-prev');
    };
    VideoShow.prototype.closeWindow = function () {
        this.$emit('close-video');
    };
    VideoShow.prototype.getVideoData = function () {
        var _this = this;
        this.fetchingPage = true;
        var apiUrl = "".concat(this.fetchPageUrl, "/").concat(this.slug);
        var visibleUrl = "".concat(this.visiblePageUrl, "/").concat(this.slug);
        window.history.pushState({}, 'Video', visibleUrl);
        return this.http
            .get(apiUrl)
            .then(function (res) {
            var _a;
            if (!((_a = res.data) === null || _a === void 0 ? void 0 : _a.video)) {
                throw new Error('Response data is empty.');
            }
            _this.video = res.data.video;
        })
            .finally(function () {
            _this.fetchingPage = false;
        });
    };
    VideoShow.prototype.toggleFavoriteVideo = function (video) {
        var _this = this;
        if (!this.video) {
            console.warn('Property "video" is empty');
            return;
        }
        (0, video_preview_1.toggleFavorite)(video, this.http)
            .then(function (data) {
            if (!_this.video) {
                console.warn('Property "video" is empty');
                return;
            }
            if (data.favorited) {
                _this.video.favorited = true;
                return;
            }
            if (!data.favorited) {
                _this.video.favorited = false;
                return;
            }
        });
    };
    VideoShow.prototype.buildUrl = function (relativePath) {
        return this.http.defaults.baseURL + relativePath;
    };
    VideoShow.prototype.scrollTop = function () {
        window.scrollTo({ top: 0 });
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true })
    ], VideoShow.prototype, "http", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true })
    ], VideoShow.prototype, "slug", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            default: function () {
                return {
                    showNavbar: true,
                    showNavButtons: false,
                    showCloseButton: false,
                    hasNext: false,
                    hasPrev: false,
                };
            }
        })
    ], VideoShow.prototype, "navbar", void 0);
    VideoShow = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                ButtonFavorite: ButtonFavorite_vue_1.default,
                ShareModal: ShareModal_vue_1.default
            }
        })
    ], VideoShow);
    return VideoShow;
}(vue_1.default));
exports.default = VideoShow;
